import { registerComponent } from '@gig/magic-common';
import TimeComponent from './time.vue.js';

var Time = registerComponent(TimeComponent);

export { Time };
